import React, { useState } from "react";
import "components/client/dashboard/profile/Cards/cards.css";
import { IoClose } from "react-icons/io5";
import { FaRegLightbulb } from "react-icons/fa";
import "components/homeRedesign/css/request-demo.css";
import LoginInput from "./auth/common/LoginInput";
import { makeToast } from "helpers/common";
import { sendSuggestionRequest } from "services/emailService";

interface MyRepCaresProps {
  fromDrawer?: boolean;
}
interface iSupportFormData {
  suggestion?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}
const MyRepCares: React.FC<MyRepCaresProps> = ({ fromDrawer = false }) => {
  const [showSideBar, setShowSideBar] = useState<boolean>(false);
  const [formData, setFormData] = useState<iSupportFormData>({});
  const [loading, setLoading] = useState<boolean>(false);

  const handleChange = (prop: string) => (value: string | boolean) => {
    setFormData((prev: iSupportFormData) => ({
      ...prev,
      [prop]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!formData.suggestion) {
      makeToast("Please provide a valid Suggestion", "error");
    } else {
      try {
        setLoading(true);
        const response = await sendSuggestionRequest(formData);
        if (response.success) makeToast(response.message, "success");
        else makeToast(response.message, "error");
        setFormData({});
        setLoading(false);
        setShowSideBar(false);
      } catch (error) {
        console.log({ error });
        setLoading(false);
        makeToast("Something went wrong, please try again latter", "error");
        setFormData({});
        setShowSideBar(false);
      }
    }
  };
  return (
    <>
      <button
        className={fromDrawer ? "drawer-nav-link" : "fab-help-button"}
        onClick={() => setShowSideBar((prev) => !prev)}
      >
        {fromDrawer ? (
          <>
            <FaRegLightbulb style={{ width: 20, height: 20, margin: 0 }} />

            <span>MyRep Cares</span>
          </>
        ) : (
          "MyRep Cares"
        )}
      </button>
      <div
        className={`custom-scroll-sm mrc-sidebar ${showSideBar ? "open" : ""}`}
      >
        <div className="mrc-sidebar-content">
          <button
            className="mrc-close-btn"
            onClick={() => setShowSideBar(false)}
          >
            <IoClose style={{ color: "#000", fontSize: 20, margin: 0 }} />
          </button>
          <p className="rd-title">Need Help?</p>
          <p className="rd-subtitle">{`Our team is ready to assist.`}</p>

          <div className="rd-from-container" style={{ padding: "1em 0px" }}>
            <LoginInput
              label="Have a Suggestion?"
              value={formData?.suggestion}
              name={"suggestion"}
              onChange={handleChange}
              type="area"
              placeholder="Share your ideas with us!"
            />
            <LoginInput
              label={"First Name"}
              value={formData?.firstName}
              name={"firstName"}
              onChange={handleChange}
              type="text"
              placeholder={"First Name"}
              customInputFieldStyle={{ color: "#3F77CD" }}
            />
            <LoginInput
              label={"Last Name"}
              value={formData?.lastName}
              name={"lastName"}
              onChange={handleChange}
              type="text"
              placeholder={"Last Name"}
              customInputFieldStyle={{ color: "#3F77CD" }}
            />
            <LoginInput
              label={"Email"}
              value={formData?.email}
              name={"email"}
              onChange={handleChange}
              type="text"
              placeholder={"Email Address"}
              customInputFieldStyle={{ color: "#3F77CD" }}
            />
            <LoginInput
              label={"Phone"}
              value={formData?.phone}
              name={"phone"}
              onChange={handleChange}
              type="text"
              placeholder={"Phone Number"}
              customInputFieldStyle={{ color: "#3F77CD" }}
            />
            <button
              className="login-form-btn"
              onClick={handleSubmit}
              disabled={loading || !formData.suggestion}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>

      {showSideBar && (
        <div className="mrc-overlay" onClick={() => setShowSideBar(false)} />
      )}
    </>
  );
};

export default MyRepCares;
